import styles from './styles.module.css';

interface WifiItemProps {
  name: string;
  freq: number;
  bssid: string;
  onPress?: () => void;
  isSelected: boolean;
}

const freqToString = (freq: number): string => {
  if (freq < 3000) {
    return '2.4GHz';
  }
  return '5GHz';
};

const WifiItem = ({
  name,
  freq,
  bssid,
  isSelected,
  onPress,
}: WifiItemProps) => (
    <div
      className={`${styles.container} ${isSelected ? styles.containerSelected : styles.containerNotSelected}`}
      onClick={onPress}
    >
      <div className={styles.innerContainer}>
        <p className={styles.name}>{name}</p>
        <p className={styles.details}>
          {freqToString(freq)} BSSID {bssid}
        </p>
      </div>
    </div>
);

export default WifiItem;
